type Props = {
  children: React.ReactNode;
};

export const VuiSpansCell = ({ children }: Props) => {
  return <div className="vuiSpansCell">{children}</div>;
};
